import {Button, Card, Col, Row, Typography, Layout, Space, Tag, Image, Rate} from "antd";
import {
    CheckCircleTwoTone,
    MobileOutlined,
    TableOutlined, FontSizeOutlined, QuestionCircleOutlined,
} from "@ant-design/icons";
import Reviews from "./elements/Reviews";
import {goToPageNotPremium} from "../../utils/goToPage";
import {NavigationPages} from "../../../common/navigation/navigation-pages";
import {useNavigate} from "react-router-dom";
import {FaPen} from "react-icons/fa";
import {ImInsertTemplate} from "react-icons/im";
import {IoMdBook} from "react-icons/io";
import {TbCards} from "react-icons/tb";
import Constants from "../../../const/Constants";
import {useEffect, useState} from "react";
import {useAppSelector} from "../../../store/hooks";
import {userSelector} from "../../../store/global";

const { Title, Paragraph, Text } = Typography;
const { Header, Content, Footer } = Layout;

const languages = [
    "Английский",
    "Немецкий",
    "Французский",
    "Испанский",
    "Китайский",
    "Итальянский",
    "Японский",
    "Корейский",
    "Турецкий",
    "Русский"
];

const methods = [
    { name: "Карточки", icon: <TbCards style={{ fontSize: 36, color: "#2d50ba" }} /> },
    { name: "Тесты", icon: <QuestionCircleOutlined style={{ fontSize: 36, color: "#fa8c16" }} /> },
    { name: "Заполнение пропусков", icon: <FontSizeOutlined style={{ fontSize: 36, color: "#13c2c2" }} /> },
    { name: "Филворды", icon: <TableOutlined style={{ fontSize: 36, color: "#52c41a" }} /> },
];


export default function LandingPageV2() {

    const user = useAppSelector(userSelector)

    useEffect(() => {
        if (user) {
            goToPageNotPremium(NavigationPages.GARDEN, navigate)
        }
    }, [user])

    const [value, setValue] = useState(4.7); // дефолтная оценка
    const navigate = useNavigate()

    const handleChange = (val) => {
        setValue(val);
        registration();
    };

    const login = () => {
        goToPageNotPremium(NavigationPages.SIGN_IN, navigate)
    }

    const registration = () => {
        goToPageNotPremium(NavigationPages.SIGN_UP, navigate)
    }


    return (
        <Layout style={{ minHeight: "100vh", background: "#fff" }}>
            {/* Header */}
            <Header
                style={{
                    background: "#fff",
                    borderBottom: "1px solid #f0f0f0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 40px",
                }}
            >
                <Title level={3} style={{ margin: 0, color: "#2d50ba" }}>
                    VoxLingua
                </Title>
                <Space>
                    <Button type="link" onClick={login}>Войти</Button>
                    <Button type="primary" onClick={registration}>Регистрация</Button>
                </Space>
            </Header>

            <Content>
                {/* Hero Section */}
                <section style={{ textAlign: "center", padding: "80px 20px" }}>
                    <Title level={1}>Учите языки через ваши собственные словари 🚀</Title>
                    <Paragraph style={{ fontSize: "18px", maxWidth: 700, margin: "20px auto" }}>
                        Создавайте словари вручную, из книг, текста или с помощью ИИ.
                        Учите слова в карточках, тестах, упражнениях и играх.
                    </Paragraph>
                    <Button type="primary" size="large" onClick={registration}>
                        Начать бесплатно
                    </Button>
                </section>

                {/* Возможности заполнения словаря */}
                <section style={{ padding: "60px 20px", background: "#fafafa" }}>
                    <Title level={2} style={{ textAlign: "center", marginBottom: 40 }}>
                        Формируйте словарь любым способом
                    </Title>
                    <Row gutter={[24, 24]} justify="center">
                        {[
                            { icon: <FaPen />, text: "Ручное добавление слов" },
                            { icon: <ImInsertTemplate /> , text: "Заполнение по шаблону" },
                            { icon: <IoMdBook />, text: "Загрузка книг и автоизвлечение слов" },
                            { icon: <CheckCircleTwoTone twoToneColor="#52c41a" />, text: "ИИ-подбор слов" },
                        ].map((item, index) => (
                            <Col xs={24} md={12} lg={6} key={index}>
                                <Card hoverable style={{ textAlign: "center", height: "100%" }}>
                                    <div style={{ fontSize: 32, marginBottom: 16 }}>{item.icon}</div>
                                    <Paragraph>{item.text}</Paragraph>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </section>

                {/* Методы обучения */}
                <section style={{ padding: "60px 20px" }}>
                    <Title level={2} style={{ textAlign: "center", marginBottom: 40 }}>
                        4 способа учить слова
                    </Title>
                    <Row gutter={[24, 24]} justify="center">
                        {methods.map((m, i) => (
                            <Col xs={24} sm={12} md={6} key={i}>
                                <Card hoverable style={{ textAlign: "center", padding: "20px 10px" }}>
                                    <div style={{ marginBottom: 16 }}>{m.icon}</div>
                                    <Title level={4}>{m.name}</Title>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </section>

                {/* Языки */}
                <section style={{ padding: "60px 20px", background: "#fafafa" }}>
                    <Title level={2} style={{ textAlign: "center", marginBottom: 40 }}>
                        Поддерживаемые языки
                    </Title>
                    <Row justify="center" gutter={[8, 8]}>
                        {languages.map((lang, i) => (
                            <Tag key={i} color="blue" style={{ fontSize: "16px", padding: "6px 12px" }}>
                                {lang}
                            </Tag>
                        ))}
                    </Row>
                </section>

                {/* Мобильные приложения */}
                <section style={{ padding: "60px 20px" }}>
                    <Row align="middle" gutter={[40, 40]} justify="center">
                        <Col xs={24} md={12}>
                            <Title level={2}>Учите где угодно 📱</Title>
                            <Paragraph style={{ fontSize: "16px" }}>
                                У нас есть приложения для <b>iOS</b> и <b>Android</b>.
                                Ваш прогресс всегда синхронизируется.
                            </Paragraph>
                            <Space>
                                <Button icon={<MobileOutlined />} type="primary" href={Constants.APPLE_STORE_LINK} target={'_blank'}>
                                    Скачать для iOS
                                </Button>
                                <Button icon={<MobileOutlined />} href={Constants.GOOGLE_PLAY_LINK} target={'_blank'}>Скачать для Android</Button>
                            </Space>
                        </Col>
                        <Col xs={24} md={8} style={{ textAlign: "center" }}>
                            <Title level={2} style={{ marginBottom: 16 }}>
                                Оцените приложение
                            </Title>
                            <Rate
                                allowHalf
                                value={value}
                                onChange={handleChange} // интерактивно
                                style={{ fontSize: 36, color: "#faad14" }}
                            />
                            <Paragraph style={{ marginTop: 16, fontSize: 16 }}>
                                На основе 2 345 отзывов. Более 5 000 довольных пользователей!
                            </Paragraph>
                        </Col>
                    </Row>
                </section>

                {/* Отзывы */}
                <section style={{ padding: "60px 20px", background: "#fafafa" }}>
                    <Title level={2} style={{ textAlign: "center", marginBottom: 40 }}>
                        Отзывы пользователей
                    </Title>
                    <Reviews count={1} />
                </section>

                {/* Финальный CTA */}
                <section style={{ padding: "80px 20px", textAlign: "center" }}>
                    <Title level={2}>Начните учить слова уже сегодня</Title>
                    <Paragraph style={{ fontSize: "16px", marginBottom: 32 }}>
                        Регистрация занимает меньше минуты, и вы сразу можете создавать свои словари.
                    </Paragraph>
                    <Button type="primary" size="large" onClick={registration}>
                        🚀 Зарегистрироваться бесплатно
                    </Button>
                </section>
            </Content>

            <Footer style={{ textAlign: "center", background: "#fff" }}>
                VoxLingua © {new Date().getFullYear()} — Учите языки легко
            </Footer>
        </Layout>
    );
}
